module.exports = __webpack_public_path__ + "static/media/YM31_1.a7445be2.jpg";